import * as Reflux from "reflux";

/**
 * Actions handled by the SummaryPageStore
 */
export const SummaryPageActions = {
	onApplyVoucher: Reflux.createAction(["onApplyVoucher"]),
	onResetVoucherError: Reflux.createAction(["onResetVoucherError"]),
	onRemoveVoucher: Reflux.createAction(["onRemoveVoucher"]),
	toggleBlockSubmit: Reflux.createAction(["toggleBlockSubmit"]),
	onSubmitCheckout: Reflux.createAction(["onSubmitCheckout"]),
};
